module.exports = __webpack_public_path__ + "img/ais-sar.571d97b0.svg";